import moment from 'moment';
import React, { Fragment } from 'react';
import { AvailabilityProps } from '../../../../redux/locker-wise-availability/interfaces/lockerWiseAvailability.interface';
import { Data } from '../../../availability/interfaces/Availability.interface';
import styles from './DifferentUnitAvailability.module.css';
import { AvailabilityGroup, FinalGroupedSlot } from '../types';

interface DifferentUnitAvailabilityProps {
    data: Data;
    differentUnitsAvailabilities: FinalGroupedSlot[] | [];
    locationData: any;
}

interface TimeSlot {
    openTime: string;
    closeTime: string;
}

interface MergedData {
    [unitId: string]: {
        unitId: string;
        availability: AvailabilityProps[];
    };
}

const removeDuplicates = (array: AvailabilityProps[]) => {
    const seen = new Set();
    return array.filter((item: any) => {
        const duplicate = seen.has(item.value);
        seen.add(item.value);
        return !duplicate;
    });
};

const mergeObjectsWithSameUnitId = (data: any) => {
    const mergedData: MergedData = {};

    data.forEach((item: any) => {
        const unitId: any = item.unitId;

        if (mergedData[unitId]) {
            mergedData[unitId].availability = [...item.availability, ...mergedData[unitId].availability];
            mergedData[unitId].availability.sort((a: any, b: any) => {
                const timeA = a.value.split(':').map(Number);
                const timeB = b.value.split(':').map(Number);

                if (timeA[0] !== timeB[0]) {
                    return timeA[0] - timeB[0];
                } else {
                    return timeA[1] - timeB[1];
                }
            });
        } else {
            mergedData[unitId] = { ...item };
        }
    });

    return Object.values(mergedData).map((item) => ({
        ...item,
        availability: removeDuplicates(item.availability),
    }));
};

const DifferentUnitAvailability = ({ data, differentUnitsAvailabilities, locationData }: DifferentUnitAvailabilityProps) => {
    // let mergedData: any = [];
    // if (differentUnitsAvailabilities) {
    //     mergedData = mergeObjectsWithSameUnitId(differentUnitsAvailabilities);
    // }


    interface TimeSlotsProps {
        timeSlotsArray: TimeSlot[];
    }

    const TimeSlots = ({ timeSlotsArray }: TimeSlotsProps) => {
        // Helper function to convert time string (HH:mm) to a Date object
        const convertToDate = (time: string) => {
            const [hours, minutes] = time.split(':').map(Number);
            const date = new Date();
            date.setHours(hours, minutes, 0, 0);
            return date;
        };

        // Helper function to format Date object to HH:mm AM/PM format
        const formatTime = (date: Date) => {
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const formattedHours = hours % 12 || 12;
            const ampm = hours < 12 ? 'AM' : 'PM';

            // Return without minutes if they're 0
            return minutes === 0
                ? `${formattedHours} ${ampm}`
                : `${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
        };

        // Generate all time slots
        const allTimeSlots = timeSlotsArray?.flatMap(({ openTime, closeTime }) => {
            const startTime = convertToDate(openTime);
            const endTime = convertToDate(closeTime);
            const slots = [];
            let currentTime = startTime;

            while (currentTime < endTime) {
                const nextTime = new Date(currentTime);
                nextTime.setHours(currentTime.getHours() + 1);

                slots.push(
                    <div className={styles.slotItem} key={currentTime.toISOString()}>
                        <span>{formatTime(currentTime)}</span> - <span>{formatTime(nextTime)}</span>
                    </div>
                );

                currentTime = nextTime;
            }

            return slots;
        });

        return <div className={styles.slotListing}>{allTimeSlots}</div>;
    };

    return (
        <div className={styles.diffUnitAvailability}>
            {differentUnitsAvailabilities &&
                !!differentUnitsAvailabilities.length &&
                differentUnitsAvailabilities.map((diffUnit: any) => {

                    return (<Fragment key={diffUnit.id}>
                        <p>
                            Pre-existing availability for {diffUnit.name} {`"${diffUnit.nickName}"`}
                        </p>

                        {(diffUnit.availability?.length > 0 && diffUnit.availability[0].timeSlot) &&
                            <TimeSlots timeSlotsArray={diffUnit.availability[0].timeSlot} />
                        }
                    </Fragment>)
                })}
        </div>
    );
};

export default DifferentUnitAvailability;
